import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUserProfile } from '@/store/features/profile.slice';
import {
  ProfilePrivateDtoRead,
  useLazyHomeControllerGetSelfQuery,
} from '@/store/services/MidleNestApi.service';

export const useProfile = () => {
  const data = useSelector(selectUserProfile) as ProfilePrivateDtoRead;
  const [reloadProfile] = useLazyHomeControllerGetSelfQuery();
  return {
    profile: useMemo(() => ({ ...data }), [data]) as ProfilePrivateDtoRead,
    reloadProfile,
  };
};
